const reducerTypes = {
    CREATE_FILES_POOL: 'uploader/CREATE_FILES_POOL',
    REMOVE_FILES_POOL: 'uploader/REMOVE_FILES_POOL',
};

const uploadTypes = {
    SET_FILE: 'uploader/SET_FILE',
    ADD_FILE: 'uploader/ADD_FILE',
    REMOVE_FILE: 'uploader/REMOVE_FILE',
    UPLOAD_REQUEST: 'uploader/UPLOADE_REQUEST',
};

export default {
    ...reducerTypes,
    ...uploadTypes,
};
